import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { login } from 'common/actions/authActions';
import NotificationConductor from 'common/conductors/NotificationConductor';
import { LoginDesktop, WithClearSafariPageCache } from '@it25syv/25syv-ui';
import persistentStorage from '../PersistentStorage';
import storage from '../PersistentStorage';

class DesktopLogin extends React.Component {
    state = {
        login: '',
        pwd: '',
    };

    componentDidMount() {
        // Remove the following line when DER-3459 Login popup is fixed
        this.props.setBackground('rgba(0,0,0,0.5)');
    }

    closeModal = () => {
        // Remove the following line and uncomment `goBack()` when DER-3459 Login popup is fixed
        this.props.hideModal('LOGIN');
        //this.props.history.goBack();
    };

    componentDidUpdate(prevProps) {
        if (!prevProps.auth.user && this.props.auth.user) {
            // Remove the following line when DER-3459 Login popup is fixed
            this.props.hideModal('LOGIN');

            this.props.modalData?.onAuthSuccess &&
                this.props.modalData.onAuthSuccess();
        }

        if (this.props.auth.error && !prevProps.auth.error) {
            NotificationConductor.error(this.props.auth.error);
        }
    }

    loginHandler = (userName, password) => {
        if (userName && password) {
            this.props.login(userName, password);
            storage.saveLS({ userName: userName });
        } else {
            console.log('Handle error'); //todo handle error
        }
    };

    render() {
        // Remove the following line and uncomment another return statement when DER-3459 Login popup is fixed
        return (
            <LoginDesktop
                closeAction={this.closeModal}
                site={'heste'}
                loginByUsername={this.loginHandler}
                isFirstLogin={!persistentStorage.get('isItInitialLogin')}
            />
        );

        // return (
        //     <ModalWrapper>
        //         <LoginDesktop closeAction={this.closeModal} site={'heste'} />
        //     </ModalWrapper>
        // );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        login: (userName, password) => {
            dispatch(login(userName, password));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(WithClearSafariPageCache(DesktopLogin)));
